import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React from 'react';
import styles from './styles';
const CardStack = ({ children }) => {
    return _jsx(Box, { sx: { ...styles.stack }, children: children });
};
export default CardStack;
